import React, {useContext, useEffect} from "react";
import {Outlet, Link, useNavigate, useLocation} from "react-router-dom";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import BreadcrumbInterface from "../../interfaces/core/BreadcrumbInterface";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {CustomerInterface} from "../../interfaces/customer/CustomerInterface";

const ASSISTANT_CUSTOMER_IDS = [214167960];

export default function Layout() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const navigate = useNavigate();
    const location = useLocation();

    const customer = state.customer as CustomerInterface;

    const menu = [
        {name: 'Мои данные', icon: 'fas fa-user', link: '/account/profile', type: 'link'},
        {name: 'Новый заказ', icon: 'fas fa-shopping-bag', link: '/basket', type: 'link'},
        {name: 'Мои заказы', icon: 'fas fa-shopping-bag', link: '/account/order-list', type: 'link'},
        // Консультант пока в тесте — ссылка только у этих клиентов, страница по прямому адресу открывается у всех
        ...(ASSISTANT_CUSTOMER_IDS.includes(customer?.id) ? [{name: 'Консультант', icon: 'fas fa-comments', link: '/account/assistant', type: 'link'}] : []),
        {name: 'Скачать прайс-лист', icon: 'fas fa-download', link: '/api/srz/order/download-excel-price', type: 'download'},
    ]


    useEffect(() => {
        let breadcrumbs: BreadcrumbInterface[] = [];

        breadcrumbs.push({
            name: 'Личный кабинет',
        })
        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: breadcrumbs})
    }, []);

    const logout = () => {
        dispatch({ type: 'SET_MANAGER', payload: {manager: null, customer: null} });
        navigate('/')
    }


    return (<div className="container">
        {/* Горизонтальное мобильное меню */}
        <div className="d-lg-none mb-4 border-bottom">
            <div className="mobile-horizontal-menu bg-white rounded-3 p-2">
                <nav className="nav justify-content-center">
                    {menu.map((item, index) => {
                        const isActive = item.type === 'link' && location.pathname === item.link;
                        const className = `nav-link d-flex flex-column align-items-center py-2 px-3 rounded-2 mx-1 text-dark ${
                            isActive ? 'text-decoration-underline' : 'text-decoration-none'
                        }`;

                        if (item.type === 'download') {
                            return (
                                <a
                                    key={index}
                                    href={item.link}
                                    className="nav-link d-flex flex-column align-items-center py-2 px-3 rounded-2 mx-1 text-decoration-none text-dark"
                                    download
                                >
                                    <i className={`${item.icon} mb-1 text-primary`}></i>
                                    {item.name}
                                </a>
                            );
                        }

                        return (
                            <Link
                                key={index}
                                to={item.link}
                                className={className}
                            >
                                <i className={`${item.icon} mb-1 text-primary`}></i>
                                {item.name}
                            </Link>
                        );
                    })}
                    <span
                        className="nav-link d-flex flex-column align-items-center py-2 px-3 rounded-2 mx-1 text-decoration-none text-dark"
                        onClick={logout}
                    >
                        <i className={` mb-1 text-primary`}></i>
                        Выход
                    </span>
                </nav>
            </div>
        </div>

        <div className={'gx-3 gx-md-6 row gy-7  mb-5'}>
            {/* Вертикальное меню для десктопа */}
            <div className="col-0 col-lg-3 d-none d-lg-block position-relative">
                <div className="filter rounded-4">
                    <nav className="nav flex-column pb-4 pt-5">
                        {menu.map((item, index) => {
                            const isActive = item.type === 'link' && location.pathname === item.link;
                            const className = `nav-link d-flex align-items-center pb-3 px-3 rounded-2 mb-2 text-dark ${
                                isActive ? 'text-decoration-underline' : 'text-decoration-none'
                            }`;

                            if (item.type === 'download') {
                                return (
                                    <a
                                        key={index}
                                        href={item.link}
                                        className="nav-link d-flex align-items-center pb-3 px-3 rounded-2 mb-2 text-decoration-none text-dark"
                                        download
                                    >
                                        <i className={`${item.icon} me-3 text-primary`}></i>
                                        {item.name}
                                    </a>
                                );
                            }

                            return (
                                <Link
                                    key={index}
                                    to={item.link}
                                    className={className}
                                >
                                    <i className={`${item.icon} me-3 text-primary`}></i>
                                    {item.name}
                                </Link>
                            );
                        })}
                        <span
                            className="pointer nav-link d-flex align-items-center pb-3 px-3 rounded-2 mb-2 text-decoration-none text-dark"
                            onClick={logout}

                        >
                            <i className={` me-3 text-primary`}></i>
                            <b>Выход</b>
                        </span>
                        <span className=" nav-link d-flex" >
                            {customer?.accounts?.filter((account) => account.manager).map((account, index) => (
                                <div key={index} className={'bg-white p-4 w-100 rounded-2'}>
                                    <div className={'text-muted'}><small>Ваш персональный менеджер</small></div>
                                    <h4 ><b>{account.manager.name}</b></h4>
                                    <div>
                                        <a href={`mailto:${account.manager.email}`}>
                                            {account.manager.email}
                                        </a>
                                    </div>
                                    <div className={'mt-2'}>
                                        {account.manager.phone_additional}
                                    </div>
                                </div>
                            ))}

                        </span>
                    </nav>
                </div>



            </div>
            <div className="col-12 col-lg-9">
                <Outlet/>
            </div>
        </div>
    </div>);
}